/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { Switch, TextField } from "@mui/material";
import TabPanel from "cms/links/link-selector/dialog-edit/panels/tab-panel";
import LabelledField from "components/labelled-field";
import { LinkContext } from "cms/links/link-selector/context";
import { LinkEditContext } from "cms/links/link-selector/context/edit";
import { objectHasPropertyString } from "utils/empty-exists";
import { useEditLink } from "cms/links/link-selector/dialog-edit/hooks/useEditLinks";
import { SelectedWebpageLink } from "cms/links/link-selector/dialog-edit/panels/selected-webpage-link";
import { LinkPlacementsWarning } from "cms/links/link-selector/dialog-edit/panels/link-placements-warning";
import { Logger } from "cms/utils/log/logger";

const LinkEditDetailsPanel = () => {
    
    const {
        hasLink,
        selectedTab,
        setCanSave
    } = useContext(LinkEditContext);
    const {
        selectedLink,
        setSelectedLink,
    } = useContext(LinkContext);
    
    // TODO: need to query via API to find usage of the link
    // const [showMultipleWarning,setShowMultipleWarning] = useState(false)
    const showMultipleWarning = false;
    const { classifyLink, validateLink } = useEditLink();
    const isInternal = objectHasPropertyString(selectedLink, "webpage");
    const isIntegration = selectedLink?.link_type === "integration";
    const [integration, setIntegration] = useState(isIntegration);
    const showIntegration = selectedLink?.url && (!selectedLink?.url?.startsWith("mailto:"));
    
    const onChange = (value, property, integration) => {
        const change = {
            ...selectedLink,
            [property]: value,
        };
        Logger.debug("integration", integration);
        const _link = classifyLink(change,integration);
        setSelectedLink(_link);
        const valid = validateLink(_link);
        setCanSave(valid);
    };
    const onChangeIntegration = (event) => {
        const checked = event.target.checked;
        setIntegration(checked);
        onChange(checked, "type", checked);
    };
    
    return (
        <Fragment>

            <TabPanel
                value={selectedTab}
                index={0}
                style={{ height: "100%" }}
            >
                
                {hasLink && (
                    <div style={{ paddingTop: "16px", paddingBottom: "16px" }}>

                        <LinkPlacementsWarning
                            showMultipleWarning={showMultipleWarning}
                        />
                        
                        {isInternal &&
                            <SelectedWebpageLink />
                        }
                        
                        <LabelledField label='URL' isRequired={true} className='labelField'>
                            <TextField
                                onChange={(e) => onChange(e.target.value, "url", integration)}
                                id='link-url'
                                fullWidth
                                disabled={isInternal}
                                variant="outlined"
                                value={selectedLink?.url || ""}
                            />
                        </LabelledField>
                        
                        <LabelledField label='Link text' isRequired={true} className='labelField'>
                            <TextField
                                onChange={(e) => onChange(e.target.value, "text", integration)}
                                id='link-text'
                                fullWidth
                                variant="outlined"
                                value={selectedLink?.text || ""}
                            />
                        </LabelledField>
                        
                        
                        {showIntegration &&
                            <LabelledField label="Hide External Icon (Integration)" className='labelField'>
                                <Switch
                                    checked={integration}
                                    onChange={onChangeIntegration}
                                />
                            </LabelledField>
                        }
                    </div>
                )}
            </TabPanel>

        </Fragment>
    );
};

export { LinkEditDetailsPanel };
